module.exports = __webpack_public_path__ + "img/cross4red.69b92eb3.png";